import { ContainerProps, styled } from '@mui/material'
import React from 'react'

interface DialogHeaderProps {
  children: React.ReactNode
}

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  color: 'var(--dewi_colors_gray_0)',
  gap: '1.375rem',
})

const Title = styled('div')({
  fontFamily: 'Inter',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '1.375rem',
  width: '100%',
  fontSize: '1.25rem',
  color: 'var(--dewi_colors_gray_0)',
})

const ActionsWapper = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  alignItems: 'start',
  width: '100%',
  /* Styling for the third child when there are three children */
  '& > :nth-child(2)': {
    justifySelf: 'center',
  },
  /* Styling for the third child when there are three children */
  '& > :nth-child(3)': {
    justifySelf: 'end',
  },
}))

const Actions = ({ children }: DialogHeaderProps) => {
  const count = React.Children.count(children)

  return (
    <ActionsWapper>
      {count === 2 && <span />}
      {children}
    </ActionsWapper>
  )
}

export const DialogHeader = ({
  children,
  ...rest
}: DialogHeaderProps & ContainerProps) => {
  return <Container {...rest}>{children}</Container>
}

DialogHeader.Title = Title
DialogHeader.Actions = Actions
